import { render, staticRenderFns } from "./todo.vue?vue&type=template&id=63306c7e&scoped=true&"
import script from "./todo.vue?vue&type=script&lang=js&"
export * from "./todo.vue?vue&type=script&lang=js&"
import style0 from "./todo.vue?vue&type=style&index=0&id=63306c7e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63306c7e",
  null
  
)

export default component.exports